import React, { useEffect, useState } from "react";
import {
  Spin,
  Col,
  Row,
  Typography,
  Card,
  List,
  Avatar,
  Image,
  Timeline,
  Steps,
  Collapse,
  Empty,
  Button,
  Modal,
  notification,
  Divider,
  Input,
  DatePicker,
} from "antd";
import moment from 'moment';

// Locales
import "dayjs/locale/th";
import { APIEndpointWeb, webapi } from "@client/web";
import { useCookies } from "react-cookie";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
} from "@constant/constant";
import {
  CheckCircleTwoTone,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "../../styles/grid/layout.less";
import HomeWebStatusAgent from "./HomeWebStatusAgent";
import { useHistory } from "react-router-dom";
import reject_case from "../../Image/reject_case.png";
import nocase from "../../Image/nocase.png";
import { Dayjs } from "dayjs";

const { Text } = Typography;
const { Step } = Steps;
const { Panel } = Collapse;
const { Search } = Input;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const limit = 5;
let gPage = 1;
export interface IInsurance {
  insurance_name: string;
  request_date: string;
  name: string;
  cid: string;
  hospital_name: string;
  hcode: string;
  steps: [];
  logo: string;
}
export interface ChildProps {
  resUserDisplayLogo?: any;
}
export interface IStep {
  date: string;
  status: string;
}
const HomeStatusAgent: React.FC<ChildProps> = (props): JSX.Element => {
  const [startDate, setStartDate] = useState("")
  const { resUserDisplayLogo } = props;
  const [resInsuranceStep, setResInsuranceStep] = useState<IInsurance[]>();
  const [resdataLogo, setResdataLogo] = useState<IInsurance[]>();
  const [loading, setLoading] = useState(false);
  const [postMedHistory, setPostMedHistory] = useState();
  const [WindowResize, setWindowResize] = useState(Number);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comment, setComment] = useState<any>('');
  const [endDate, setEndDate] = useState("")
  const [docid, setDocid] = useState<any>();
  const [resSelectdate, setResSelectdate] = useState<Dayjs | any>('');
  const [resSearchName, setresSearchName] = useState("");
  const history = useHistory();
  const dayjs = require("dayjs");
  const utc = require("dayjs/plugin/utc");
  const timezone = require("dayjs/plugin/timezone");
  dayjs.extend(timezone);
  dayjs.extend(utc);

  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);
  useEffect(() => {
    checkCookie();

  }, [resUserDisplayLogo]);
  useEffect(() => {
    getStatusLoading(gPage, '', resSelectdate, startDate, endDate);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const onChangePagination = async (page: number): Promise<void> => {
    gPage = page;
    await getStatusLoading(gPage, resSearchName, resSelectdate, startDate, endDate);
  };
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = async () => {
    const payload = {
      document_id: docid,
      comment: comment,
    };
    try {
      const { data } = await webapi.post(
        `${APIEndpointWeb.RequestIncomplete}`,
        payload,
        {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        }
      );
      // if (data.result) {
      //     window.location.reload();
      // }
      notification.success({
        message: "ส่งข้อความเรียบร้อยแล้ว"
      });
      // setLoading(false);
    } catch (error) {
      console.log(error);
    }
    setIsModalOpen(false);
    setComment('')
  };
  const checkCookie = async () => {
    webapi
      .get(`${APIEndpointWeb.checkCookie}`, {
        withCredentials: true,
      })
      .then(() => { })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 401) {
          history.push("/login");
        }
      });
  };
  const commentToHospital = (documentid: any) => {
    setIsModalOpen(true);
    setDocid(documentid)
  };
  const onChangeStartDateEndDate = (dateStrings: any) => {
    const sDate = dateStrings ? dateStrings[0].format(dateFormat) : ''
    const eDate = dateStrings ? dateStrings[1].format(dateFormat) : ''
    setStartDate(sDate)
    setEndDate(eDate)
    getStatusLoading(1, resSearchName, resSelectdate, sDate, eDate)
  };
  const getStatusLoading = async (page: number, datasearch: any, datadate: any, dataSDate: string, dataEDate: string) => {
    setLoading(true);
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.GetStatusAgent}?search=${datasearch}&limit=${limit}&page=${page}&date=${datadate}&startDate=${dataSDate}&endDate=${dataEDate}`, {
        withCredentials: true,
        // headers: { Authorization: `Bearer ${cookies.shared_token}` }
      });
      setResInsuranceStep(data.result ? data.result : []);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const confirm = (item: any, documentid: any) => {
    Modal.confirm({
      title: "ยืนยันได้รับประวัติการรักษา",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: async (): Promise<void> => {
        const databody = {
          document_id: documentid,
          status: "Approve",
        };
        try {
          const { data } = await webapi.post(
            `${APIEndpointWeb.GetInsuranceNotify}`,
            databody,
            {
              withCredentials: true,
              // headers: { Authorization: `Bearer ${cookies.shared_token}` }
            }
          );
          if (data.result) {
            window.location.reload();
          }
          setPostMedHistory(data);
          notification.success({
            message: "ได้รับประวัติการรักษาแล้ว",
          });
          setLoading(false);
        } catch (error) {
          console.log(error);
        }
        setLoading(false);
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" },
      },
    });
  };
  const caseCancle = (doc_id: any) => {
    Modal.confirm({
      title: "คุณแน่ใจที่จะยกเลิกใช่หรือไม่?",
      icon: <ExclamationCircleOutlined />,
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      async onOk() {
        const dataStatus = {
          document_id: doc_id,
          status: true,
        };
        try {
          const { data } = await webapi.post(
            `${APIEndpointWeb.RejectRequest}`,
            dataStatus,
            {
              withCredentials: true,
              // headers: { Authorization: `Bearer ${cookies.shared_token}` }
            }
          );
          getStatusLoading(1, resSearchName, resSelectdate, startDate, endDate)
        } catch (error) {
          console.log(error);
        }
      },
      onCancel() {
        console.log("ยกเลิก");
      },
    });
  };
  const handleKeyPress = (event: any, data: any): void => {
    if (event.key === "Enter") {
      getStatusLoading(1, data, resSelectdate, startDate, endDate);
    }
  };
  const onChangeDate = (dateString: any) => {
    const dString = dateString ? dateString.format(dateFormat) : ''
    setResSelectdate(dString);
    getStatusLoading(1, resSearchName, dString, startDate, endDate);
  };
  function disabledDate(current: any) {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
  }
  return (
    <>
      {WindowResize < 1024 ? (
        <div >
          <Spin
            tip="กำลังโหลด..."
            spinning={loading}
            style={{ height: "100vh" }}
          >
            {/* <> */}

            <div>
              <Card style={{
                overflowY: 'hidden',
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.25)",
                borderRadius: "20px",
                position: 'sticky',
                top: 92,
                zIndex: 1,
              }}
                className="m-3"
              >
                <Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                    <Text style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}>กำหนดระยะวันที่ค้นหา</Text>
                    <RangePicker
                      className="mt-2"
                      placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
                      style={{ width: "100%", borderRadius: "10px", height: "34px" }}
                      format={dateFormat}
                      disabledDate={disabledDate}
                      onChange={onChangeStartDateEndDate}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="mt-2">
                    <Text style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}>
                      ค้นหาชื่อหรือเลขที่เอกสาร
                    </Text>
                    <Row className="mt-2">
                      <Col xs={18} sm={18} md={18} lg={18} xl={18} xxl={18} >
                        <Input
                          placeholder="กรุณากรอกข้อมูล"
                          allowClear
                          onKeyDown={(event: any) => handleKeyPress(event, resSearchName)}
                          style={{ borderRadius: "10px", height: "34px", width: '100%' }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                            const idNo = e.target.value;
                            const re = /^[A-Za-z\s0-9ก-๛]+$/;
                            if (idNo === "" || re.test(e.target.value)) {
                              setresSearchName(e.target.value);
                            }
                            if (!e.target.value) {
                              getStatusLoading(1, "", resSelectdate, startDate, endDate);
                            }
                          }}
                          value={resSearchName}
                        />
                      </Col>
                      <Col xs={5} sm={5} md={5} lg={5} xl={5} xxl={4} className="ml-2">
                        <Button block onClick={() => getStatusLoading(1, resSearchName, resSelectdate, startDate, endDate)}
                          style={{ borderRadius: "10px", color: "#ffffff", backgroundColor: "#147F8B", height: "34px" }}>
                          ค้นหา
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="mt-2">
                    <Text style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}  >
                      ค้นหาข้อมูลตามวันที่
                    </Text>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <DatePicker
                          className="mt-2 marl-4 widtDate"
                          placeholder="กรุณาเลือกวันที่"
                          format={dateFormat}
                          onChange={onChangeDate}
                          disabledDate={disabledDate}

                        />
                      </Col>
                    </Row>
                  </Col>
                </Col>
              </Card>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <Row
                // style={{ scrollbarGutter: "auto" }}
                >
                  {resInsuranceStep && resInsuranceStep.length > 0 ? (
                    <>
                      <List
                        style={{ width: '100%' }}
                        itemLayout="vertical"
                        dataSource={resInsuranceStep}
                        renderItem={(item: any) => (
                          <List.Item>
                            <Card
                              className="ml-3 mr-3"
                              size="small"
                              style={{
                                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.25)",
                                borderRadius: "20px",
                                // backgroundColor: item.status === "Rejected" ? "#E0E0E0" : '#fff'
                              }}
                            >
                              <Row>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  style={{
                                    marginTop: "-1rem",
                                    marginBottom: "-2rem",
                                  }}
                                >
                                  <Collapse
                                    className="collapse-status"
                                    ghost
                                    bordered={false}
                                    defaultActiveKey={["0"]}
                                    expandIconPosition="right"
                                  >
                                    <Panel
                                      header={
                                        <Row>
                                          <Col
                                            className="image-padding-center"
                                            xs={6}
                                            sm={6}
                                            md={6}
                                            lg={6}
                                            xl={6}
                                            xxl={6}
                                          >

                                            <List.Item.Meta
                                              avatar={
                                                <Avatar
                                                  size={60}
                                                  style={{
                                                    backgroundColor: "#E5E5E5",
                                                  }}
                                                  src=
                                                  {resUserDisplayLogo && resUserDisplayLogo !== undefined ? (
                                                    <Image
                                                      preview={false}
                                                      src={`data:image/jpeg;base64,${resUserDisplayLogo}`}
                                                      style={{
                                                        marginTop: "5px",
                                                      }}
                                                    />
                                                  ) : ''}
                                                />
                                              }
                                            />
                                          </Col>
                                          <Col
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              wordBreak: "break-word",
                                            }}
                                            className="mt-3"
                                            xs={18}
                                            sm={18}
                                            md={18}
                                            lg={18}
                                            xl={18}
                                            xxl={18}
                                          >
                                            <List.Item.Meta
                                              title={
                                                <Col>
                                                  <div className="font-title">
                                                    <Text
                                                      strong
                                                      style={{ color: "black" }}
                                                    >
                                                      {item.insurance_name}
                                                    </Text>
                                                    <br />
                                                    <Text
                                                      style={{ color: "black" }}
                                                    >
                                                      วันที่ร้องขอ{" "}
                                                      {dayjs(item.request_date)
                                                        .subtract(7, "hour")
                                                        .add(543, "year")
                                                        .format("DD/MM/YYYY")}
                                                    </Text>{" "}
                                                    <br />
                                                    <Typography.Text>
                                                      สถานะ :
                                                    </Typography.Text>
                                                    {item.steps[0].step_1.status ===
                                                      "Pending" ? (
                                                      <Typography.Text
                                                        style={{ color: "#147F8B" }}
                                                      >
                                                        รอผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                      </Typography.Text>
                                                    ) : item.steps[0].step_2
                                                      .status === "Pending" ? (
                                                      <Typography.Text
                                                        style={{ color: "#147F8B" }}
                                                      >
                                                        รอแพทย์ยืนยันข้อมูลประวัติการรักษา
                                                      </Typography.Text>
                                                    ) : item.steps[0].step_3
                                                      .status === "Pending" ? (
                                                      <Typography.Text
                                                        style={{ color: "#147F8B" }}
                                                      >
                                                        รอบริษัทประกันยืนยันได้รับข้อมูลประวัติการรักษา
                                                      </Typography.Text>
                                                    ) : item.steps[0].step_4
                                                      .status === "Success" ? (
                                                      <Typography.Text
                                                        style={{ color: "#147F8B" }}
                                                      >
                                                        เสร็จสิ้น
                                                      </Typography.Text>
                                                    ) : item.steps[0].step_4
                                                      .status === "Pending" ? (
                                                      <Typography.Text
                                                        style={{ color: "#147F8B" }}
                                                      >
                                                        เสร็จสิ้น
                                                      </Typography.Text>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                  <Divider
                                                    style={{
                                                      marginBottom: "10px",
                                                      marginTop: "10px",
                                                      maxWidth: "auto",
                                                    }}
                                                  />
                                                </Col>
                                              }
                                            />
                                          </Col>
                                          <Row
                                            className="mb-4"
                                            justify="space-around"
                                          >
                                            <Col
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                            >
                                              <div
                                                className="ml-2 font-card-panel"
                                                style={{ marginBottom: "10px" }}
                                              >
                                                <Text style={{ color: "black" }}>
                                                  รายละเอียดผู้ขอประวัติการรักษา
                                                </Text>
                                                <br />
                                                <Text strong style={{ color: "black" }}>
                                                  เลขที่เอกสารอ้างอิง :{" "}
                                                </Text>
                                                <Text style={{ fontSize: '13px' }}>
                                                  {item.document_id}
                                                </Text>
                                                <br />
                                                <Text
                                                  strong
                                                  style={{ color: "black" }}
                                                >
                                                  {" "}
                                                  ชื่อ:
                                                </Text>{" "}
                                                <Text style={{ color: "black" }}>
                                                  {item.name}
                                                </Text>
                                                <br />
                                                <Text
                                                  strong
                                                  style={{ color: "black" }}
                                                >
                                                  {" "}
                                                  ชื่อโรงพยาบาล:
                                                </Text>{" "}
                                                <Text style={{ color: "black" }}>
                                                  {item.hospital_name}
                                                </Text>
                                                <br />
                                                {/* <Text style={{ color: "black" }}>
                                              โรงพยาบาล :
                                            </Text>
                                            <br />
                                            <Text
                                              strong
                                              style={{ color: "black" }}
                                            >
                                              {item.hospital_name}
                                            </Text> */}
                                                {/* <br /> */}
                                                <Text
                                                  strong
                                                  style={{ color: "black" }}
                                                >
                                                  Hospital code:
                                                </Text>{" "}
                                                <Text>{item.hcode}</Text>
                                                <br />
                                              </div>
                                            </Col>
                                          </Row>
                                        </Row>
                                      }
                                      key="1"
                                    >
                                      <List.Item.Meta
                                        title={
                                          <div>
                                            {Object.keys(item.steps).length > 0 ? item.steps.map(
                                              (step: any, index: number,) => (
                                                item.status === "Rejected"
                                                  ? (
                                                    <Col className="image_reject">
                                                      <Image
                                                        alt="lodo"
                                                        src={reject_case}
                                                        preview={false}
                                                        style={{
                                                          width: "58%",
                                                        }}
                                                      />
                                                    </Col>
                                                  ) : item.status === "Rejected From Hospital" ? (
                                                    <Col className="image_reject">
                                                      <Image
                                                        alt="lodo"
                                                        src={nocase}
                                                        preview={false}
                                                        style={{
                                                          width: "58%",
                                                        }}
                                                      />
                                                    </Col>
                                                  ) : (
                                                    <div key={index}>
                                                      <Timeline
                                                        mode="left"
                                                        className="dotline-timeline"
                                                      >
                                                        <Timeline.Item
                                                          className={
                                                            step.step_1.status ===
                                                              "Success"
                                                              ? "dot-bg"
                                                              : "dot-cdcdcd" &&
                                                                step.step_1
                                                                  .status ===
                                                                "Waiting"
                                                                ? "dot-bg-yellow"
                                                                : "dot-bg-yellow" &&
                                                                  step.step_1
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "dot-bg-yellow"
                                                                  : "dot-cdcdcd"
                                                          }
                                                          color={
                                                            step.step_1.status ===
                                                              "Success"
                                                              ? "#147F8B"
                                                              : "gray" &&
                                                                step.step_1
                                                                  .status ===
                                                                "Waiting"
                                                                ? "gray"
                                                                : "gray" &&
                                                                  step.step_1
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "#D6B400"
                                                                  : "gray"
                                                          }
                                                          style={{
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {/* {items.step_1.status === "Success" ? ( */}
                                                          <Step
                                                            style={{
                                                              color:
                                                                step.step_1
                                                                  .status ===
                                                                  "Success"
                                                                  ? "#147F8B"
                                                                  : "gray" &&
                                                                    step.step_1
                                                                      .status ===
                                                                    "Waiting"
                                                                    ? "gray"
                                                                    : "gray" &&
                                                                      step.step_1
                                                                        .status ===
                                                                      "Pending"
                                                                      ? "#D6B400"
                                                                      : "gray",
                                                            }}
                                                            title={
                                                              dayjs(step.step_1.date).locale("th").add(543, "year").format("DD/MMMM/YYYY") === "01/มกราคม/544" ? "" :
                                                                dayjs(step.step_1.date).locale("th").format("DD/MM/YYYY HH:mm น.")
                                                            }
                                                            subTitle={
                                                              step.step_1.status ===
                                                                "Success" ? (
                                                                <Typography.Text
                                                                  className="font-title"
                                                                  style={{
                                                                    color:
                                                                      "#147F8B",
                                                                  }}
                                                                  strong
                                                                >
                                                                  อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                </Typography.Text>
                                                              ) : "" ||
                                                                step.step_1
                                                                  .status ===
                                                                "Waiting" ? (
                                                                <Typography.Text
                                                                  className="font-title"
                                                                  style={{
                                                                    color:
                                                                      "#D6B400",
                                                                  }}
                                                                  strong
                                                                >
                                                                  อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                </Typography.Text>
                                                              ) : "" ||
                                                                step.step_1
                                                                  .status ===
                                                                "Pending" ? (
                                                                <Typography.Text
                                                                  className="font-title"
                                                                  style={{
                                                                    color:
                                                                      "#D6B400",
                                                                  }}
                                                                  strong
                                                                >
                                                                  อยู่ในขั้นตอนผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                </Typography.Text>
                                                              ) : (
                                                                ""
                                                              )
                                                            }
                                                            description={
                                                              step.step_1.status ===
                                                                "Success" ? (
                                                                <Typography className="font-card-step">
                                                                  ผู้เอาประกันยินยอมให้เข้าถึงข้อมูลแล้ว
                                                                </Typography>
                                                              ) : "" ||
                                                                step.step_1
                                                                  .status ===
                                                                "Waiting" ||
                                                                step.step_1
                                                                  .status ===
                                                                "Pending" ? (
                                                                <Typography className="font-card-step">
                                                                  รอผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                                                </Typography>
                                                              ) : (
                                                                ""
                                                              )
                                                            }
                                                          />
                                                        </Timeline.Item>

                                                        {/* //step2 */}
                                                        <Timeline.Item
                                                          className={
                                                            step.step_2.status ===
                                                              "Success"
                                                              ? "dot-bg"
                                                              : "dot-cdcdcd" &&
                                                                step.step_2
                                                                  .status ===
                                                                "Waiting"
                                                                ? "dot-cdcdcd"
                                                                : "dot-cdcdcd" &&
                                                                  step.step_2
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "dot-bg-yellow"
                                                                  : "dot-cdcdcd"
                                                          }
                                                          color={
                                                            step.step_2.status ===
                                                              "Success"
                                                              ? "#147F8B"
                                                              : "gray" &&
                                                                step.step_2
                                                                  .status ===
                                                                "Waiting"
                                                                ? "gray"
                                                                : "gray" &&
                                                                  step.step_2
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "#D6B400"
                                                                  : "gray"
                                                          }
                                                          style={{
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {/* {items.step_2.status === "Success" ? ( */}
                                                          <Step
                                                            style={{
                                                              color:
                                                                step.step_2
                                                                  .status ===
                                                                  "Success"
                                                                  ? "#147F8B"
                                                                  : "gray" &&
                                                                    step.step_2
                                                                      .status ===
                                                                    "Waiting"
                                                                    ? "gray"
                                                                    : "gray" &&
                                                                      step.step_2
                                                                        .status ===
                                                                      "Pending"
                                                                      ? "#D6B400"
                                                                      : "gray",
                                                            }}
                                                            title={
                                                              dayjs(
                                                                step.step_2.date
                                                              )
                                                                .locale("th")
                                                                .add(543, "year")
                                                                .format(
                                                                  "DD/MMMM/YYYY"
                                                                ) ===
                                                                "01/มกราคม/544"
                                                                ? ""
                                                                : dayjs(
                                                                  step.step_2.date
                                                                )
                                                                  .locale("th")
                                                                  .format(
                                                                    "DD/MM/YYYY HH:mm น."
                                                                  )
                                                            }
                                                            subTitle={
                                                              <Typography.Text
                                                                className="font-title"
                                                                style={{
                                                                  color:
                                                                    step.step_2
                                                                      .status ===
                                                                      "Success"
                                                                      ? "#147F8B"
                                                                      : "gray" &&
                                                                        step.step_2
                                                                          .status ===
                                                                        "Waiting"
                                                                        ? "gray"
                                                                        : "gray" &&
                                                                          step.step_2
                                                                            .status ===
                                                                          "Pending"
                                                                          ? "#D6B400"
                                                                          : "gray",
                                                                }}
                                                                strong
                                                              >
                                                                อยู่ในขั้นตอนแพทย์ยืนยันข้อมูลประวัติการรักษา
                                                              </Typography.Text>
                                                            }
                                                            description={
                                                              step.step_2.status ===
                                                                "Success" ? (
                                                                <Typography className="font-card-step">
                                                                  แพทย์ได้ทำการยืนยันประวัติการรักษาเรียบร้อย
                                                                </Typography>
                                                              ) : "" ||
                                                                step.step_2
                                                                  .status ===
                                                                "Waiting" ||
                                                                step.step_2
                                                                  .status ===
                                                                "Pending" ? (
                                                                <Typography className="font-card-step">
                                                                  รอแพทย์ยืนยันข้อมูลประวัติการรักษา
                                                                </Typography>
                                                              ) : (
                                                                ""
                                                              )
                                                            }
                                                          />
                                                        </Timeline.Item>

                                                        {/* //step3 */}
                                                        <Timeline.Item
                                                          className={
                                                            step.step_3.status ===
                                                              "Success"
                                                              ? "dot-bg"
                                                              : "dot-cdcdcd" &&
                                                                step.step_3
                                                                  .status ===
                                                                "Waiting"
                                                                ? "dot-cdcdcd"
                                                                : "dot-cdcdcd" &&
                                                                  step.step_3
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "dot-bg-yellow"
                                                                  : "dot-cdcdcd"
                                                          }
                                                          color={
                                                            step.step_3.status ===
                                                              "Success"
                                                              ? "#147F8B"
                                                              : "gray" &&
                                                                step.step_3
                                                                  .status ===
                                                                "Waiting"
                                                                ? "gray"
                                                                : "gray" &&
                                                                  step.step_3
                                                                    .status ===
                                                                  "Pending"
                                                                  ? "#D6B400"
                                                                  : "gray"
                                                          }
                                                          style={{
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {/* {items.step_3.status === "Success" ? ( */}
                                                          <Step
                                                            style={{
                                                              color:
                                                                step.step_3
                                                                  .status ===
                                                                  "Success"
                                                                  ? "#147F8B"
                                                                  : "gray" &&
                                                                    step.step_3
                                                                      .status ===
                                                                    "Waiting"
                                                                    ? "gray"
                                                                    : "gray" &&
                                                                      step.step_3
                                                                        .status ===
                                                                      "Pending"
                                                                      ? "#D6B400"
                                                                      : "gray",
                                                            }}
                                                            title={
                                                              dayjs(
                                                                step.step_3.date
                                                              )
                                                                .locale("th")
                                                                .add(543, "year")
                                                                .format(
                                                                  "DD/MMMM/YYYY"
                                                                ) ===
                                                                "01/มกราคม/544"
                                                                ? ""
                                                                : dayjs(
                                                                  step.step_3.date
                                                                )
                                                                  .locale("th")
                                                                  .format(
                                                                    "DD/MM/YYYY HH:mm น."
                                                                  )
                                                            }
                                                            subTitle={
                                                              <Typography.Text
                                                                className="font-title"
                                                                style={{
                                                                  color:
                                                                    step.step_3
                                                                      .status ===
                                                                      "Success"
                                                                      ? "#147F8B"
                                                                      : "gray" &&
                                                                        step.step_3
                                                                          .status ===
                                                                        "Waiting"
                                                                        ? "gray"
                                                                        : "gray" &&
                                                                          step.step_3
                                                                            .status ===
                                                                          "Pending"
                                                                          ? "#D6B400"
                                                                          : "gray",
                                                                }}
                                                                strong
                                                              >
                                                                อยู่ในขั้นตอนบริษัทประกันยืนยันได้รับข้อมูลประวัติการรักษา
                                                              </Typography.Text>
                                                            }
                                                            description={
                                                              step.step_3.status ===
                                                                "Success" ? (
                                                                <Typography className="font-card-step">
                                                                  บริษัทประกันได้รับการยืนยันข้อมูลประวัติการรักษา
                                                                </Typography>
                                                              ) : "" ||
                                                                step.step_3
                                                                  .status ===
                                                                "Waiting" ||
                                                                step.step_3
                                                                  .status ===
                                                                "Pending" ? (
                                                                <Typography className="font-card-step">
                                                                  บริษัทประกันยังไม่ยืนยันได้ข้อมูลประวัติการรักษา
                                                                </Typography>
                                                              ) : (
                                                                ""
                                                              )
                                                            }
                                                          />
                                                          <Row className="mt-2">
                                                            <Col xs={11} sm={11} md={11} lg={11} xl={11} xxl={11} >
                                                              <Button
                                                                disabled={step.step_1.status !== "Success" || step.step_2.status !== "Success" || step.step_3.status !== "Pending" ? true : false}
                                                                style={{ borderRadius: 30, width: 'auto' }}
                                                                onClick={() => confirm(step, item.document_id)}
                                                                type="primary"
                                                                block
                                                              >
                                                                ยืนยันได้รับข้อมูล
                                                              </Button>
                                                            </Col>
                                                            <Col className="" xs={11} sm={11} md={11} lg={11} xl={11} xxl={11} >
                                                              <Button
                                                                disabled={
                                                                  step.step_1.status !== "Success" ||
                                                                    step.step_2.status !== "Success" ||
                                                                    step.step_3.status !== "Pending"
                                                                    ? true
                                                                    : false
                                                                }
                                                                style={{ borderRadius: 15, width: 'auto' }}
                                                                onClick={() => commentToHospital(item.document_id)}
                                                                block
                                                              >
                                                                แจ้งเอกสารไม่ครบ
                                                              </Button>
                                                            </Col>
                                                          </Row>
                                                        </Timeline.Item>

                                                        {/* //step4 */}
                                                        <Timeline.Item
                                                          className={
                                                            postMedHistory === "OK"
                                                              ? "dot-bg"
                                                              : "dot-cdcdcd" &&
                                                                step.step_4
                                                                  .status ===
                                                                "Success"
                                                                ? "dot-bg"
                                                                : "dot-cdcdcd" &&
                                                                  step.step_4
                                                                    .status ===
                                                                  "Waiting"
                                                                  ? "dot-cdcdcd"
                                                                  : "dot-cdcdcd" &&
                                                                    step.step_4
                                                                      .status ===
                                                                    "Pending"
                                                                    ? "dot-bg"
                                                                    : "dot-cdcdcd"
                                                          }
                                                          color={
                                                            postMedHistory === "OK"
                                                              ? "#147F8B"
                                                              : "gray" &&
                                                                step.step_4
                                                                  .status ===
                                                                "Success"
                                                                ? "#147F8B"
                                                                : "gray"
                                                          }
                                                          style={{
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {/* {items.step_4.status === "Success" ? ( */}
                                                          <Step
                                                            style={{
                                                              color:
                                                                postMedHistory ===
                                                                  "OK"
                                                                  ? "#147F8B"
                                                                  : "gray" &&
                                                                    step.step_4
                                                                      .status ===
                                                                    "Success"
                                                                    ? "#147F8B"
                                                                    : "gray" &&
                                                                      step.step_4
                                                                        .status ===
                                                                      "Pending"
                                                                      ? "#147F8B"
                                                                      : "gray",
                                                            }}
                                                            title={
                                                              dayjs(
                                                                step.step_4.date
                                                              )
                                                                .locale("th")
                                                                .add(543, "year")
                                                                .format(
                                                                  "DD/MMMM/YYYY"
                                                                ) ===
                                                                "01/มกราคม/544"
                                                                ? ""
                                                                : dayjs(
                                                                  step.step_4.date
                                                                )
                                                                  .locale("th")
                                                                  .format(
                                                                    "DD/MM/YYYY HH:mm น."
                                                                  )
                                                            }
                                                            subTitle={
                                                              <Typography.Text
                                                                className="font-title"
                                                                style={{
                                                                  color:
                                                                    postMedHistory ===
                                                                      "OK"
                                                                      ? "#147F8B"
                                                                      : "gray" &&
                                                                        step.step_4
                                                                          .status ===
                                                                        "Success"
                                                                        ? "#147F8B"
                                                                        : "gray" &&
                                                                          step.step_4
                                                                            .status ===
                                                                          "Waiting"
                                                                          ? "gray"
                                                                          : "gray" &&
                                                                            step.step_4
                                                                              .status ===
                                                                            "Pending"
                                                                            ? "#147F8B"
                                                                            : "gray",
                                                                }}
                                                                strong
                                                              >
                                                                การดำเนินการเสร็จสิ้น
                                                              </Typography.Text>
                                                            }
                                                            description={
                                                              step.step_4.status ===
                                                                "Success" ? (
                                                                <Typography className="font-card-step">
                                                                  บริษัทประกันยืนยันได้รับประวัติการรักษาแล้ว
                                                                </Typography>
                                                              ) : "" ||
                                                                step.step_4
                                                                  .status ===
                                                                "Waiting" ||
                                                                step.step_4
                                                                  .status ===
                                                                "Pending" ? (
                                                                <Typography className="font-card-step">
                                                                  บริษัทประกันยืนยันได้รับประวัติการรักษาแล้ว
                                                                </Typography>
                                                              ) : (
                                                                ""
                                                              )
                                                            }
                                                          />
                                                        </Timeline.Item>
                                                      </Timeline>
                                                    </div>
                                                  )
                                              )
                                            )
                                              : ""}
                                            {/* </Card> */}
                                          </div>
                                        }
                                      />
                                    </Panel>
                                  </Collapse>
                                </Col>
                              </Row>
                              <Col
                                style={{
                                  justifyContent: "flex-end",
                                  display: "flex",
                                }}
                              >
                                {item.status === "Rejected" ? (
                                  <Button className="buttonCancle" disabled>
                                    ยกเลิกแล้ว
                                  </Button>
                                ) : item.status === "Rejected From Hospital" ? (
                                  <Button className="buttonCancle" disabled>
                                    คำร้องไม่มีประวัติการรักษา
                                  </Button>
                                ) : (
                                  <Button
                                    className="buttonCancle"
                                    onClick={() => caseCancle(item.document_id)}
                                  >
                                    ยกเลิก
                                  </Button>
                                )}
                              </Col>
                            </Card>
                          </List.Item>
                        )}
                      />
                    </>
                  ) : (
                    <Row>
                      <Col
                        className="mt-5 pt-5"
                        style={{
                          height: "100vh",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={"ไม่มีข้อมูลของสถานะการดำเนินการ11"}
                        />
                      </Col>
                    </Row>
                  )}
                </Row>
              </Col>
            </div>
            {/* </> */}

            <Modal title="แจ้งเอกสารไม่ครบ" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
              <Input.TextArea placeholder='comment...' style={{ width: '100%', borderRadius: '8px' }} rows={3}
                value={comment} onChange={(e) => { setComment(e.target.value) }}
              />
            </Modal>
          </Spin>
        </div >
      ) : (
        <HomeWebStatusAgent />
      )}
    </>
  );
};

export default HomeStatusAgent;
